// utils/auth.js
import store from '../store/index'
/**
 * 权限管理工具类
 */
class AuthUtil {
  /**
   * 获取权限列表
   */
  static getPermissions() {
    try {
      const userInfo = JSON.parse(localStorage.getItem('user')|| '{}')
      return userInfo.authMenu || []
    } catch (error) {
      return []
    }
  }

  /**
   * 检查是否有权限
   * @param {string|string[]} permission 权限字符串或数组
   * @returns {boolean}
   */
  static has(permission) {
    const permissions = this.getPermissions()
    
    // 如果没有权限要求，默认通过
    if (!permission) return true
    
    // 超级管理员检查（如果有is_super字段）
    const userInfo = JSON.parse(localStorage.getItem('user') || '{}')
    if (userInfo.auth.admin_type === 0) {
      return true
    }
    
    // 数组处理：任意一个权限满足即可
    if (Array.isArray(permission)) {
      return permission.some(p => permissions.includes(p))
    }
    
    // 字符串处理
    return permissions.includes(permission)
  }

  /**
   * 检查是否没有权限
   */
  static lacks(permission) {
    return !this.has(permission)
  }

  /**
   * 检查是否拥有所有权限
   */
  static hasAll(permissions) {
    if (!Array.isArray(permissions)) {
      return this.has(permissions)
    }
    return permissions.every(p => this.has(p))
  }

  /**
   * 检查是否拥有任意一个权限
   */
  static hasAny(permissions) {
    if (!Array.isArray(permissions)) {
      return this.has(permissions)
    }
    return permissions.some(p => this.has(p))
  }
}

export default AuthUtil